import { CONSOLE_PROCESSOR } from "../console-stub.mjs";
export { CONSOLE_PROCESSOR };
